"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralInput = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _styles = require("./styles");

var _InputFormatter = require("../InputFormatter");

var _CheckBox = require("../CheckBox");

var _jsxRuntime = require("react/jsx-runtime");

var GeneralInput = function GeneralInput(_ref) {
  var inputType = _ref.inputType,
      inputId = _ref.inputId,
      inputName = _ref.inputName,
      _ref$inputValue = _ref.inputValue,
      inputValue = _ref$inputValue === void 0 ? "" : _ref$inputValue,
      inputPlaceholder = _ref.inputPlaceholder,
      validateInput = _ref.validateInput,
      position = _ref.position,
      inputsArray = _ref.inputsArray,
      inputSize = _ref.inputSize,
      articleId = _ref.articleId,
      updatedDatasheets = _ref.updatedDatasheets,
      setUpdatedDatasheets = _ref.setUpdatedDatasheets,
      updatedDescriptions = _ref.updatedDescriptions,
      setUpdatedDescriptions = _ref.setUpdatedDescriptions,
      maxChar = _ref.maxChar,
      isRequired = _ref.isRequired,
      version = _ref.version,
      _ref$optionList = _ref.optionList,
      optionList = _ref$optionList === void 0 ? [] : _ref$optionList,
      description = _ref.description,
      inputOnChange = _ref.inputOnChange,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      auditClass = _ref.auditClass;

  var _useState = (0, _react.useState)({
    value: inputValue
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      textValue = _useState2[0],
      setTextValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      requiredEmpty = _useState4[0],
      setRequiredEmpty = _useState4[1];

  var onHandleChange = function onHandleChange(evt) {
    if (validateInput) {
      setTextValue({
        value: validateInput(evt, position, inputsArray)
      });
    } else if (updatedDatasheets || updatedDescriptions || inputType === "textarea") {
      var generalValue;

      if ((optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0) {
        var valueSelected = evt.target.value;
        generalValue = valueSelected;
        setTextValue({
          value: generalValue
        });
      } else {
        generalValue = inputType === "checkbox" ? evt.target.checked : evt.target.value;
        setTextValue({
          value: generalValue
        });
      }

      var dataSave = updatedDatasheets === null || updatedDatasheets === void 0 ? void 0 : updatedDatasheets.slice();

      if ((dataSave === null || dataSave === void 0 ? void 0 : dataSave.length) > 0) {
        var index = dataSave.findIndex(function (e) {
          return e.attributeId === inputId;
        });

        if (index !== -1) {
          if (generalValue !== inputValue) dataSave[index].value = generalValue;else dataSave.splice(index, 1);
        } else {
          dataSave.push({
            articleId: articleId,
            attributeId: inputId,
            value: generalValue
          });
        }
      } else {
        if (generalValue !== inputValue) {
          dataSave.push({
            articleId: articleId,
            attributeId: inputId,
            value: generalValue
          });
        }
      }

      setUpdatedDatasheets(dataSave);
    } else {
      setTextValue({
        value: evt.target.value
      });
      inputOnChange && inputOnChange(evt);
    }
  };

  (0, _react.useEffect)(function () {
    var _textValue$value;

    setRequiredEmpty(isRequired && (((_textValue$value = textValue.value) === null || _textValue$value === void 0 ? void 0 : _textValue$value.length) === 0 || textValue.value === undefined));
  }, [textValue]);

  var numberInputOnWheelPreventChange = function numberInputOnWheelPreventChange(e) {
    // Prevent the input value change
    e.target.blur(); // Prevent the page/container scrolling

    e.stopPropagation(); // Refocus immediately, on the next tick (after the current function is done)

    setTimeout(function () {
      return e.target.focus();
    }, 0);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    isRequired: requiredEmpty,
    className: auditClass,
    children: [(optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      id: "dropdown".concat(inputId),
      onChange: function onChange(e) {
        return onHandleChange(e);
      },
      defaultValue: textValue.value,
      disabled: disabled,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: "",
        children: description
      }), JSON.parse(optionList || "[]").map(function (element, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: element,
          children: element
        }, element + "-" + index);
      })]
    }, "dropdownK".concat(inputId)) : inputType === "checkbox" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
      id: inputId,
      onChange: function onChange(e) {
        return onHandleChange(e);
      },
      defaultChecked: textValue.value === "true" ? true : false,
      disabled: disabled
    }) : inputType !== "textarea" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: inputType,
      disabled: disabled,
      id: inputId,
      size: inputSize,
      className: "general-input",
      placeholder: inputPlaceholder,
      value: textValue.value,
      onInput: function onInput(e) {
        return onHandleChange(e);
      },
      maxLength: maxChar,
      required: isRequired,
      onKeyDown: onKeyDown,
      onWheel: numberInputOnWheelPreventChange
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputFormatter.InputFormatter, {
      name: inputName,
      inputId: inputId,
      placeholder: inputPlaceholder,
      mainValue: textValue.value,
      onChange: onHandleChange,
      articleId: articleId,
      updatedDescriptions: updatedDescriptions,
      setUpdatedDescriptions: setUpdatedDescriptions,
      maxChar: maxChar,
      isRequired: isRequired,
      disabled: disabled
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: description
    })]
  });
};

exports.GeneralInput = GeneralInput;